<template>
  <!-- 这个是正文 -->
  <div class="id_5">

    <div class="title" :class="{'bold': data.bold}" v-html="data.title"></div>

  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_5'
}
</script>

<style lang="scss" scoped>
.id_5{
  background-color: #fff;
  padding-top: 16px;
  font-size: 14px;
  line-height: 22px;
  color: #303133;
  word-wrap:break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_5.vue